// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are Navigateed to the login page.
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "contexts/AuthContext";

const PrivateRoute = ({ children }) => {
  // Add your own authentication on the below line.
  const { activeUser } = useAuthContext();

  if (!activeUser) {
    localStorage.setItem("redirectPath", window.location.pathname);
    return <Navigate to="/login" replace={true} />;
  }

  return children;
};

export default PrivateRoute;
